import React from 'react';

// Tinted surface instead of white-card-plus-colored-border — the color
// carries the tile, not a thin rail beside it. Kept to five roles so it
// reads as a considered vocabulary (informational / achieved / attention /
// urgent / positive), not a rainbow assigned by card position.
const COLORS = {
  blue: { bg: 'bg-primary-50', text: 'text-primary-700', icon: 'text-primary-600' },
  green: { bg: 'bg-emerald-50', text: 'text-emerald-700', icon: 'text-emerald-600' },
  yellow: { bg: 'bg-amber-50', text: 'text-amber-700', icon: 'text-amber-600' },
  purple: { bg: 'bg-purple-50', text: 'text-purple-700', icon: 'text-purple-600' },
  red: { bg: 'bg-red-50', text: 'text-red-700', icon: 'text-red-600' },
};

export default function StatCard({ label, value, icon, color = 'blue', onClick }) {
  const c = COLORS[color] || COLORS.blue;
  const Wrapper = onClick ? 'button' : 'div';
  return (
    <Wrapper
      onClick={onClick}
      className={`relative overflow-hidden rounded-2xl ${c.bg} p-4 text-left w-full ${onClick ? 'hover:brightness-[0.97] active:scale-[0.99] transition' : ''}`}
    >
      {icon && (
        <div className={`absolute -right-3 -bottom-3 w-16 h-16 ${c.icon} opacity-[0.14] pointer-events-none`}>
          {icon}
        </div>
      )}
      <div className="relative">
        <p className={`text-xs font-medium ${c.text} opacity-80 truncate`}>{label}</p>
        <p className={`text-3xl font-display font-bold ${c.text} mt-1 tabular-nums`}>{value}</p>
      </div>
    </Wrapper>
  );
}
